export class SignupModel {
  public personMasterHashId: string;
  public userName: string;
  public firstName: string;
  public middleName: string;
  public lastName: string;
  public countryCode1: string = '';
  public countryCode2: string = '';
  public telephone1: string;
  public telephone2: string;
  public personHomeAddressModel: PersonAddressModel;
  public personWorkAddressModel: PersonAddressModel;
  public password: string;
  public confirmPassword: string;
  public email: string;
  public confirmEmail: string;
  public instanceId: string;
  public instanceHashId: string = '';
  public personRole: string[] = [];
  public signupParam: string;
  public createdDateTime: string;
  public status: string;
  public signupFormdescription: string;
  public OrganizationHashId: string;
  //public selectedSubscription :  string[] = [];
  public svgWiseSubscriptionList: any;
  public isAccepted: boolean = false;
  public isPrivacyStatementAccepted: boolean = false;
  public acceptedTermsAndConditionsHashIdList: string[];
  public privacyHashId: string;
  public nifNumber: string;
  public isnifEnabled: boolean = false;
  public countryCodeHashId:string;
  public rfidTagId: string;
  public licenseTypes: string;
  public certificates: string;
  public employeeNumber: string;
  public accessCardId: string;
  
  constructor() {
    this.personHomeAddressModel = new PersonAddressModel();
    this.personWorkAddressModel = new PersonAddressModel();
  }
}

export class PersonAddressModel {
  public houseNo: string;
  public houseExtention: string;
  public street: string;
  public city: string;
  public zipCode: string;
  public address: string;
  public latitiude: number;
  public logitude: number;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/signup/models/signup.model.ts